"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConsultantNameFormatters = void 0;
var _mobileOfficeApiClientReact = require("@ori/mobile-office-api-client-react");
var _getFullNameFormat = require("./getFullNameFormat");
const useConsultantNameFormatters = () => {
  const {
    data: configuration
  } = (0, _mobileOfficeApiClientReact.useGetConfigurationDeprecated)();
  const fullNameFormat = (0, _getFullNameFormat.getFullNameFormat)(configuration);
  return {
    getFormattedConsultantName(firstName, lastName) {
      return fullNameFormat.replace('{FirstName}', firstName ?? '').replace('{LastName}', lastName ?? '')
      // not supported formats should be cleaned
      .replace('{Greeting}', '').replace('{Gender}', '');
    },
    getCapitalisedInitials(firstName, lastName) {
      return fullNameFormat.replaceAll(' ', '').replace('{FirstName}', (firstName ?? '').slice(0, 1).toUpperCase()).replace('{LastName}', (lastName ?? '').slice(0, 1).toUpperCase())
      // Gender or Greeting are ignored in initials
      .replace('{Greeting}', '').replace('{Gender}', '');
    }
  };
};
exports.useConsultantNameFormatters = useConsultantNameFormatters;
